import type { AbilityBuilder } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineRecurringInvoiceAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can } = abilityBuilder

  const roles = userRoles(user)

  if (roles.administrator) {
    can('read', 'recurring-invoices')
    can(['create', 'read', 'update', 'delete', 'restore'], 'recurring-invoice')
  }
}
